var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7407 8.23123L18.195 9.73437C18.5175 10.0685 18.5175 10.5985 18.1967 10.9319L16.7424 12.435C16.6589 12.5214 16.6198 12.6414 16.6366 12.7604L16.9292 14.831C16.9942 15.291 16.6825 15.7202 16.225 15.8002L14.1651 16.1615C14.0467 16.1822 13.9446 16.2565 13.8882 16.3626L12.9083 18.2094C12.69 18.6194 12.1867 18.7835 11.7692 18.5794L9.89032 17.6613C9.78232 17.6086 9.65602 17.6086 9.54806 17.6614L7.67 18.5802C7.2525 18.7844 6.74833 18.6202 6.53083 18.2102L5.55093 16.3634C5.49461 16.2573 5.39244 16.1831 5.27407 16.1623L3.21417 15.801C2.75667 15.7202 2.445 15.2919 2.51 14.8319L2.80253 12.7613C2.81934 12.6423 2.78031 12.5222 2.69676 12.4358L1.2425 10.9327C0.919167 10.5985 0.919167 10.0694 1.2425 9.7352L2.69676 8.23206C2.78031 8.1457 2.81934 8.02563 2.80253 7.90665L2.51 5.83604C2.445 5.37604 2.75667 4.9477 3.21417 4.8677L5.27403 4.50644C5.39243 4.48568 5.49461 4.41143 5.55093 4.30525L6.53083 2.4577C6.74833 2.0477 7.2525 1.88354 7.66917 2.0877L9.54812 3.0058C9.65605 3.05853 9.78228 3.05853 9.89021 3.0058L11.7692 2.0877C12.1858 1.88354 12.69 2.0477 12.9067 2.45687L13.8866 4.30363C13.9429 4.40979 14.0451 4.48401 14.1634 4.50477L16.2233 4.86604C16.6808 4.94687 16.9925 5.3752 16.9275 5.8352L16.635 7.90582C16.6182 8.02479 16.6572 8.14487 16.7407 8.23123Z",
    fill: "#055AEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4020_570447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37539 12.0746L6.80039 10.4996L6.27539 11.0246L8.37539 13.1246L12.8754 8.62461L12.3504 8.09961L8.37539 12.0746Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4020_570447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.a9fbe757.svg";
export { ForwardRef as ReactComponent };